var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"auto"}},[_c('iframe',{ref:"iframeRef",attrs:{"frameborder":"0","scrolling":"auto","id":_vm.id,"src":_vm.furl,"width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }